class info_tp2_algorithm_journal_edit extends Tango.Component {
	widgetDidMount() {

		var _this = this;

		document.querySelectorAll('[id="info_tp2_algorithm_journal_edit_algos_deletebtn"]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				document.getElementById('info_tp2_algorithm_journal_edit_archdatadiffreasoncase_id').setAttribute('value', '-1');

				var priority = btn.getAttribute("data-priority");
				priority = priority == 0 ? -1 : priority;
				document.getElementById("info_tp2_algorithm_journal_edit_algorithm_priority").setAttribute("value", priority.toString());
			});
		});

		document.querySelectorAll('[id^="info_tp2_algorithm_journal_edit_algos_rb_"]').forEach(function (radio) {
			radio.addEventListener('click', function () {
				document.getElementById('info_tp2_algorithm_journal_edit_archdatadiffreasoncase_id').setAttribute('value', '-1');

				var priority = radio.getAttribute("data-priority");
				priority = priority == 0 ? -1 : priority;
				document.getElementById("info_tp2_algorithm_journal_edit_algorithm_priority").setAttribute("value", priority.toString());
			});
		});
	}
}
Tango.registerComponent(info_tp2_algorithm_journal_edit, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));